// extracted by mini-css-extract-plugin
export var currencyInput = "_kd-1";
export var currencySymbol = "_kd-0";